import { Injectable, signal } from '@angular/core';
import { IBrandProfile } from '../interfaces/brand-profile';
import { IDisbursementSession } from '../interfaces/disbursement-session';

@Injectable({
  providedIn: 'root'
})
export class SharedSignalService {

  private envRegionSignal = signal('');
  private dsbSessionGuidSignal = signal('');
  private dsbSessionSignal = signal(<IDisbursementSession> {});
  private brandProfileSignal = signal(<IBrandProfile> {});

  readonly envRegion = this.envRegionSignal.asReadonly();
  readonly dsbSessionGuid = this.dsbSessionGuidSignal.asReadonly();
  readonly dsbSession = this.dsbSessionSignal.asReadonly();
  readonly brandProfile = this.brandProfileSignal.asReadonly();

  constructor() { }

  setEnvRegion(envRegion: string) {
    this.envRegionSignal.set(envRegion);
  }

  setDsbSessionGuid(dsbSessionGuid: string) {
    this.dsbSessionGuidSignal.set(dsbSessionGuid);
  }

  setDsbSession(dsbSession: IDisbursementSession) {
    this.dsbSessionSignal.set(dsbSession);
  }

  setBrandProfile(brandProfile: IBrandProfile) {
    this.brandProfileSignal.set(brandProfile);
  }

}
